var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.56962V7.00019M7.5 9.43076H7.50622M6.43616 1.44633L1.16674 10.0384C1.0581 10.2222 1.00061 10.4305 1 10.6427C0.999397 10.8549 1.05569 11.0636 1.16327 11.2479C1.27086 11.4323 1.426 11.5859 1.61325 11.6935C1.8005 11.8011 2.01333 11.859 2.23058 11.8613H12.7694C12.9867 11.859 13.1995 11.8011 13.3868 11.6935C13.574 11.5859 13.7291 11.4323 13.8367 11.2479C13.9443 11.0636 14.0006 10.8549 14 10.6427C13.9994 10.4305 13.9419 10.2222 13.8333 10.0384L8.56384 1.44633C8.45293 1.26775 8.29677 1.1201 8.11043 1.01763C7.92409 0.91516 7.71385 0.861328 7.5 0.861328C7.28615 0.861328 7.07592 0.91516 6.88957 1.01763C6.70323 1.1201 6.54707 1.26775 6.43616 1.44633Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.315c4503b964eab99f67959f91d53656.svg";
export { ForwardRef as ReactComponent };